export var getMaskedPhoneNumber = function (phone) {
    var phoneNumber = phone.replace(/\D/g, '');
    var phoneLength = phoneNumber.length;
    if (phoneLength > 3 && phoneLength <= 6) {
        return "".concat(phoneNumber.substring(0, 3), "-").concat(phoneNumber.substring(3));
    }
    if (phoneLength > 6) {
        return "".concat(phoneNumber.substring(0, 3), "-").concat(phoneNumber.substring(3, 6), "-").concat(phoneNumber.substring(6, 10));
    }
    return phoneNumber;
};
